import { render, staticRenderFns } from "./ShippingKittingPreferencesModal.vue?vue&type=template&id=a719fd16&scoped=true"
import script from "./ShippingKittingPreferencesModal.vue?vue&type=script&lang=js"
export * from "./ShippingKittingPreferencesModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingKittingPreferencesModal.vue?vue&type=style&index=0&id=a719fd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a719fd16",
  null
  
)

export default component.exports